import { twMerge } from "tailwind-merge";

const Card = ({
  size = "md",
  className,
  children,
}: {
  size?: string;
  className?: string;
  children: React.ReactNode;
}) => {
  return (
    <div
      className={twMerge([
        "my-4 rounded-card bg-white p-4 shadow-card",
        size === "lg" && "p-6",
        size === "sm" && "rounded-control p-3 my-2 shadow-sm",
        size === "xs" && "rounded-control p-3 shadow-sm",
        className,
      ])}
    >
      {children}
    </div>
  );
};

export default Card;
